module.exports = __webpack_public_path__ + "img/1.b21b2810.png";